import { LogoMark } from "./Logo";

const WORDS = ["Talk.", "Connect.", "Keep going.", "A stronger tomorrow", "It's okay to say it"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w, i) => (
      <span key={i} className="flex items-center">
        <span className={`px-8 font-display font-black uppercase text-5xl sm:text-7xl lg:text-8xl tracking-tight ${i % 2 ? "text-outline" : "text-white"}`}>{w}</span>
        <LogoMark className="h-8 sm:h-10 w-auto opacity-90" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" aria-label="Talk. Connect. Keep going." className="relative overflow-hidden border-y border-white/10 bg-[#07090D] py-8 sm:py-10">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
